import React from 'react';
import { OibTextFieldProps } from './types';
import { isOibValid } from './validation';
import { NumberField } from '../NumberField';


const OibTextField: React.FC<OibTextFieldProps> = ({
  value,
  onChange,
  error,
  validateOnLength = true,
  placeholder = 'Unesite OIB (11 znamenki)',
  name,
  ...props
}) => {
  const oib = typeof value === 'string' ? value : (value ? String(value) : '');

  const isValid = React.useMemo(() => {
    if (!oib) return true;
    if (oib.length > 11) return false;
    if (oib.length < 11) return false;
    return isOibValid(oib);
  }, [oib]);

  const numericValue = React.useMemo(() => {
    if (!value || value === '') return null;
    const num = Number(value);
    return isNaN(num) ? null : num;
  }, [value]);

  const handleNumberChange = React.useCallback((numValue: number | null, fieldName?: string) => {
    if (onChange) {
      // Prazno polje daje prazan OIB, ne nulu.
      const strValue = numValue === null ? "" : String(Math.floor(numValue));
      const event = {
        target: {
          name: fieldName || name || '',
          value: strValue,
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  }, [onChange, name]);

  const validationError = !isValid ? 'Neispravan OIB' : (!oib ? error : undefined);

  const digitCount = oib.length;
  const hasDigits = digitCount > 0;

  return (
    <div className="relative">
      <NumberField
        {...props}
        name={name}
        value={numericValue}
        onChange={handleNumberChange}
        error={validationError}
        placeholder={placeholder}
        decimals={0}
        maxLength={11}
      />
      {hasDigits && (
        <div className="absolute -bottom-5 left-0 right-0 flex items-center justify-between px-1">
          <span className="text-xs text-slate-400">{digitCount}/11 znamenki</span>
          {digitCount === 11 && (
            <span className={`text-xs font-medium ${isValid ? "text-green-600" : "text-red-500"}`}>
              {isValid ? "Ispravan OIB" : "Neispravan OIB"}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(OibTextField);
